/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Product Express Update Element
 * @export
 * @interface ProductExpressUpdateElement
 */
export interface ProductExpressUpdateElement {
    /**
     * Code of product express update element
     * @type {string}
     * @memberof ProductExpressUpdateElement
     */
    code?: string;
    /**
     * Catalog identifier
     * @type {string}
     * @memberof ProductExpressUpdateElement
     */
    catalogId?: string;
    /**
     * Catalog version
     * @type {string}
     * @memberof ProductExpressUpdateElement
     */
    catalogVersion?: string;
}

/**
 * Check if a given object implements the ProductExpressUpdateElement interface.
 */
export function instanceOfProductExpressUpdateElement(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductExpressUpdateElementFromJSON(json: any): ProductExpressUpdateElement {
    return ProductExpressUpdateElementFromJSONTyped(json, false);
}

export function ProductExpressUpdateElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductExpressUpdateElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'catalogId': !exists(json, 'catalogId') ? undefined : json['catalogId'],
        'catalogVersion': !exists(json, 'catalogVersion') ? undefined : json['catalogVersion'],
    };
}

export function ProductExpressUpdateElementToJSON(value?: ProductExpressUpdateElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'catalogId': value.catalogId,
        'catalogVersion': value.catalogVersion,
    };
}

